import {
  zSchema,
  schemes,
  EDepositRuleType,
  depositRuleResponseSchema,
} from "@zeal/common";

const depositRuleSchema = zSchema.object({
  priority: zSchema.number().int().min(1),
  type: zSchema.nativeEnum(EDepositRuleType),
  amount: zSchema.number().min(1).optional(),
  percentage: zSchema.number().min(1).max(100).optional(),
  bankAccountID: zSchema.string(),
});

export const patchDepositRuleRequestSchema = zSchema.object({
  ruleID: schemes.uuid(),
  companyID: schemes.companyID(),
  workerID: schemes.mongoObjectId(),
  rules: zSchema.array(depositRuleSchema).min(1),
});

export type TPatchDepositRuleRequestSchema = zSchema.infer<
  typeof patchDepositRuleRequestSchema
>;

export const patchDepositRuleResponseSchema = zSchema.object({
  ruleID: schemes.uuid(),
  companyID: schemes.companyID(),
  workerID: schemes.mongoObjectId(),
  rules: zSchema.array(depositRuleResponseSchema),
});

export type TPatchDepositRuleResponseSchema = zSchema.infer<
  typeof patchDepositRuleResponseSchema
>;
